import React, { FC } from 'react';
import { CoreTheme as theme } from '@minecraft.themes';
import { PillWrapper, PillText, PillClearIcon } from './PillStyles';

type Props = {
  isNotAppliedFilterPills?: boolean;
  isPillSelected?: boolean;
  showClearIcon?: boolean;
  pillKey?: string | { label: string };
  text: string | { label: string };
  onClick?: () => void;
  className?: string;
};

const Pill: FC<Props> = ({
  isNotAppliedFilterPills,
  isPillSelected,
  showClearIcon = true,
  pillKey,
  text,
  onClick,
  className,
}) => {
  const id = (pillKey as { label: string })?.label || (pillKey as string);

  return (
    <PillWrapper
      $isNotAppliedFilterPills={isNotAppliedFilterPills}
      $isPillSelected={isPillSelected}
      id={id}
      role="button"
      className={className}
      onClick={(event): void => {
        event.stopPropagation();
        onClick?.();
      }}
      data-testid={pillKey}
    >
      <PillText>{text}</PillText>
      {showClearIcon && <PillClearIcon name="close" color={theme.colors.primary.white} />}
    </PillWrapper>
  );
};

export default Pill;
